import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updatePartnerAccounts: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<void> = async (fetchContext, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/partners`,
  {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update partner accounts'));
